import { CalendarSyncEntry, ExternalConnection, ID } from '@griply/types';

export const getCalendarSyncs = (
  connections: ExternalConnection[],
): CalendarSyncEntry[] =>
  connections.flatMap((connection) => {
    const calendarSettings = connection.settings?.calendarSettings;
    if (!calendarSettings) {
      return [];
    }

    return Object.entries(calendarSettings).map(([linkedItemId, setting]) => ({
      ...setting,
      connectionId: connection.id,
      linkedItemId: linkedItemId as ID,
    }));
  });
